/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpdateAwsIamCredentialRequestBody = {
  /**
   * The customer IAM role ARN Speakeasy assumes. Omit for a KMS key-policy grant.
   */
  assumeRoleArn?: string | undefined;
  /**
   * The ID of the credential to update.
   */
  id: string;
  /**
   * A human-readable name for the credential.
   */
  name: string;
  /**
   * The OIDC audience. Provide (with assume_role_arn) to assume the role with a web identity.
   */
  oidcAudience?: string | undefined;
  /**
   * Optional OIDC subject pin; only valid alongside oidc_audience.
   */
  oidcSubject?: string | undefined;
  /**
   * Optional STS region override.
   */
  stsRegion?: string | undefined;
};

/** @internal */
export type UpdateAwsIamCredentialRequestBody$Outbound = {
  assume_role_arn?: string | undefined;
  id: string;
  name: string;
  oidc_audience?: string | undefined;
  oidc_subject?: string | undefined;
  sts_region?: string | undefined;
};

/** @internal */
export const UpdateAwsIamCredentialRequestBody$outboundSchema: z.ZodMiniType<
  UpdateAwsIamCredentialRequestBody$Outbound,
  UpdateAwsIamCredentialRequestBody
> = z.pipe(
  z.object({
    assumeRoleArn: z.optional(z.string()),
    id: z.string(),
    name: z.string(),
    oidcAudience: z.optional(z.string()),
    oidcSubject: z.optional(z.string()),
    stsRegion: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      assumeRoleArn: "assume_role_arn",
      oidcAudience: "oidc_audience",
      oidcSubject: "oidc_subject",
      stsRegion: "sts_region",
    });
  }),
);

export function updateAwsIamCredentialRequestBodyToJSON(
  updateAwsIamCredentialRequestBody: UpdateAwsIamCredentialRequestBody,
): string {
  return JSON.stringify(
    UpdateAwsIamCredentialRequestBody$outboundSchema.parse(
      updateAwsIamCredentialRequestBody,
    ),
  );
}
